import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { InQueueWidget } from '@src/widgets/ActionPaths';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Text } from '@uhg-abyss/web/ui/Text';
import React from 'react';

import { Table } from './components/Table';

/**
 * Widget: DataContainment
 *
 * Displays a list of top 25 sources by attribute that are in data containment action path.
 *
 * @param assets
 * @param data
 * @returns {Element}
 * @constructor
 */
export function DataContainment({ assets, data }) {
  const dobData = data?.ListTopContainmentSources?.data?.dobSources;
  const ssnData = data?.ListTopContainmentSources?.data?.ssnSources;

  return (
    <ErrorHandler location="src/widgets/RiskRecords/DataContainment/DataContainment.jsx">
      <Grid>
        <Grid.Col span={12}>
          <Text fontWeight={700} size="$lg">
            DOB
          </Text>
        </Grid.Col>
        <Grid.Col span={6}>
          <Table assets={assets} rows={dobData} />
        </Grid.Col>
        <Grid.Col span={6}>
          <InQueueWidget statusCodeCounts={data?.['GetActionPathInitiatives-DOB']?.data?.statusCodeCounts} />
        </Grid.Col>
        <Grid.Col span={12}>
          <Divider />
        </Grid.Col>
        <Grid.Col span={12}>
          <Text fontWeight={700} size="$lg">
            SSN
          </Text>
        </Grid.Col>
        <Grid.Col span={6}>
          <Table assets={assets} rows={ssnData} />
        </Grid.Col>
        <Grid.Col span={6}>
          <InQueueWidget statusCodeCounts={data?.['GetActionPathInitiatives-SSN']?.data?.statusCodeCounts} />
        </Grid.Col>
      </Grid>
    </ErrorHandler>
  );
}
